<template>
  <div class="o-tasklisting">
    <div class="tasklisting__filter">
      <div class="filter__left">
        <div class="flex">
          <div>
            <v-select
              v-if="false"
              :title="filters.filterDropdown.title"
              v-model="filterDropdown"
              :items="filters.filterDropdown.options"
              :clearable="false"
              :searchable="false"
              :reduce="option => option.code"
              single-line
              menu-props="auto"
              outlined
              item-text="label"
              item-value="code"
            />
              <div class="flex">
                <div style="padding-right: 10px; font-weight:bold">{{filters.sortDropdown.title}}:</div>
                <div>
                  <v-select
                class="sortfilter"
                :append-icon="null"
                :title="filters.sortDropdown.title"
                v-model="sortDropdown"
                :items="filters.sortDropdown.options"
                :clearable="false"
                :searchable="false"
                :reduce="option => option.code"
                single-line
                menu-props="auto"
                outlined
                item-text="label"
                item-value="code"
              >
              <template v-slot:prepend-inner>
                <div class="dropdown_icon"></div>
              </template>
              </v-select>
              </div>
            </div>
          </div>
          <button class="showall plus" v-if="!allOpen" @click="openAll">
              <font-awesome-icon icon="plus" />
              {{ $t('fair.tasklisting.showall') }}
            </button>

            <button class="showall minus" v-if="allOpen" @click="collapseAll">
              <font-awesome-icon icon="minus" />
              {{ $t('fair.tasklisting.hideall') }}
            </button>
        </div>
      </div>
    </div>
    <ul class="tasklisting__list">
      <li
        class="list__item"
        v-for="group in taskListGrouped"
        v-bind:key="group._id"
      >
        <task-item-group
          :task-group="group"
          :booth="booth"
          :renderCondition="filterDropdown"
          :link="taskLinks.find(item => item.typ === task.serviceGroup)"
          :linkParams="taskLinksAttributes"
          :service-shop-id="serviceShopId"
          :startLoadingShopLinks="startLoadingShopLinks"
          :isCoexposant="isCoexposant"
          :filters="filters"
          :shopLinks="shopLinks"
          :sorting="sortDropdown"
          @updateVisible="updateGroupVisibility"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import BosButton from '@/components/BosButton'
import TaskItem from '@/components/TaskItem'
import TaskItemGroup from '@/components/TaskItemGroup'
//import { ics } from 'ics'

export default {
  name: 'TaskListing',
  props: {
    tasks: {
      type: Array,
      required: true,
      default: () => []
    },
    shopLinks: {
      type: Array,
      required: true,
      default: () => []
    },
    isCoexposant: Boolean,
    booth: String,
    serviceShopId: String,
    taskLinks: {
      type: Array,
      default: () => []
    },
    insurance: {
      type: Object,
      default: () => ({})
    },
    taskLinksAttributes: {},
    startLoadingShopLinks: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      taskCollapse: [],
      filterDropdown: 'all',
      sortDropdown: 'all',
      allminified: true,
      allOpen: false,
      tL: this.tasks,
      groupVisibility: {}
    }
  },
  computed: {
    filters() {
      return {
        view: {
          list: {
            isActive: true,
            icon: 'list',
            title: this.$t('components.taskListing.filter.view.list')
          },
          sort: {
            isActive: false,
            icon: 'sort-amount-down',
            title: this.$t('components.taskListing.filter.view.sort')
          }
        },
        sortDropdown: {
          title: this.$t('components.taskListing.filter.sortDropdown.title'),
          options: [
          {
              label: this.$t(
                'components.taskListing.filter.sortDropdown.options.all'
              ),
              code: 'all'
            },
            {
              label: this.$t(
                'components.taskListing.filter.sortDropdown.options.done'
              ),
              code: 'done'
            },
            {
              label: this.$t(
                'components.taskListing.filter.sortDropdown.options.notdone'
              ),
              code: 'notdone'
            },
            {
              label: this.$t(
                'components.taskListing.filter.sortDropdown.options.ascending'
              ),
              code: 'ascending'
            },
            {
              label: this.$t(
                'components.taskListing.filter.sortDropdown.options.descending'
              ),
              code: 'descending'
            },
          ]
        },
        filterDropdown: {
          title: this.$t('components.taskListing.filter.filterDropdown.title'),
          options: [
            {
              label: this.$t(
                'components.taskListing.filter.filterDropdown.options.all'
              ),
              code: 'all'
            },
            {
              label: this.$t(
                'components.taskListing.filter.filterDropdown.options.pendent'
              ),
              code: 'pendent'
            },
            {
              label: this.$t(
                'components.taskListing.filter.filterDropdown.options.due'
              ),
              code: 'due'
            },
            {
              label: this.$t(
                'components.taskListing.filter.filterDropdown.options.overdue'
              ),
              code: 'overdue'
            },
            {
              label: this.$t(
                'components.taskListing.filter.filterDropdown.options.done'
              ),
              code: 'done'
            }
          ]
        }
      }
    },
    taskListGrouped() {
      let retVal = []
      let currentGroup = null
      let list = this.taskList
      for (let listId in this.taskList) {
        let task = list[listId]
        switch (task.type) {
          case 'taskTitle':
            currentGroup = {
              title: task.title,
              serviceGroup: task.serviceGroup,
              deeplinkmode: task.deeplinkmode,
              manualdeeplinktargetblank: task.manualdeeplinktargetblank,
              url: task.url,
              _id: task._id,
              tasks: []
            }
            retVal.push(currentGroup)
            break
          default:
            if (currentGroup === null) {
              currentGroup = {
                title: '',
                serviceGroup: '',
                _id: '_NONE_',
                tasks: []
              }
              retVal.push(currentGroup)
            }
            currentGroup.tasks.push(task)
            break
        }
      }

      
      return retVal.sort(this.sort)
    },
    taskList() {
      let taskList = JSON.parse(JSON.stringify(this.tL))
      if (this.filters.view.sort.isActive) {
        taskList = taskList
          .sort((taskA, taskB) => {
            let a = {
              time: new Date(
                (taskA.period || {}).end || '9999-01-31T23:59:59.999Z'
              ),
              name: taskA.displayName
            }

            let b = {
              time: new Date(
                (taskB.period || {}).end || '9999-01-31T23:59:59.999Z'
              ),
              name: taskB.displayName
            }

            a.time.setUTCHours(23)
            a.time.setUTCMinutes(59)
            a.time.setUTCSeconds(59)
            a.time.setUTCMilliseconds(999)
            a.time.getTime()

            b.time.setUTCHours(23)
            b.time.setUTCMinutes(59)
            b.time.setUTCSeconds(59)
            b.time.setUTCMilliseconds(999)
            b.time.getTime()

            let sortProperty = a.time === b.time ? 'name' : 'time'

            return a[sortProperty] > b[sortProperty]
              ? 1
              : a[sortProperty] < b[sortProperty]
              ? -1
              : 0
          })
          .filter(task => task.period)
      }

      return taskList
    }
  },
  methods: {
    updateGroupVisibility(group, visibility) {
      this.groupVisibility[group._id] = visibility
    },
    sort(a, b) {
      if (this.sortDropdown === 'done') {
        return this.spaceship(
          a.tasks.filter((item) => item.isDone == false || item.notificationState !== false).length, 
          b.tasks.filter((item) => item.isDone == false || item.notificationState !== false).length);
      }
      if (this.sortDropdown === 'notdone') {
        return this.spaceship(
          a.tasks.filter((item) => item.isDone == true || item.notificationState === false).length, 
          b.tasks.filter((item) => item.isDone == true || item.notificationState === false).length);
      }
      if (this.sortDropdown === 'ascending') {
        return this.spaceship(a.title, b.title);
      }
      if (this.sortDropdown === 'descending') {
        return this.spaceship(b.title, a.title);
      }
      return 0
    },
    spaceship(val1, val2) {
      if ((val1 === null || val2 === null) || (typeof val1 != typeof val2)) {
        return null;
      }
      if (typeof val1 === 'string') {
        return (val1).localeCompare(val2);
      } else {
        if (val1 > val2) {
          return 1;
        } else if (val1 < val2) {
          return -1;
        }
        return 0;
      }
    },
    collapseAll() {
      this.taskCollapse.forEach(item => {
        this.$root.$emit('bv::toggle::collapse', item)
      })
    },
    openAll() {
      for (let group in this.taskListGrouped) {
        if (this.groupVisibility[this.taskListGrouped[group]._id]) {
          this.$root.$emit(
            'bv::toggle::collapse',
            this.taskListGrouped[group]._id
          )
        }
      }
    },
    exortTaksAsIcal() {
      // Prepare tasks for expor.
      let tasksToExport = []

      this.taskList.forEach(task => {
        const dateToUse = task.period
          ? task.period.end || task.period.start
          : null

        if (
          task.period &&
          task.period.start !== undefined &&
          task.period.start !== null &&
          task.period.end !== undefined &&
          task.period.end !== null &&
          task.displayName
        ) {
          tasksToExport.push({
            start: [
              new Date(dateToUse).getFullYear(),
              new Date(dateToUse).getMonth(),
              new Date(dateToUse).getDay(),
              9,
              0
            ],
            end: [
              new Date(dateToUse).getFullYear(),
              new Date(dateToUse).getMonth(),
              new Date(dateToUse).getDay() + 1,
              9,
              0
            ],
            title: task.displayName,
            description: ' \n',
            //location: 'Folsom Field, University of Colorado (finish line)',
            //url: 'http://www.bolderboulder.com/',
            //geo: { lat: 40.0095, lon: 105.2669 },
            //categories: ['10k races', 'Memorial Day Weekend', 'Boulder CO'],
            //status: 'CONFIRMED',
            //busyStatus: 'BUSY',
            organizer: {
              name: 'BernExpo OneShop',
              email: 'service@bernexpo.com'
            }
            /*attendees: [
            {
              name: 'Adam Gibbons',
              email: 'adam@example.com',
              rsvp: true,
              partstat: 'ACCEPTED',
              role: 'REQ-PARTICIPANT'
            },
            {
              name: 'Brittany Seaton',
              email: 'brittany@example2.org',
              dir: 'https://linkedin.com/in/brittanyseaton',
              role: 'OPT-PARTICIPANT'
            }
          ]*/
          })
        }
      })

      /*const { error, value } = ics.createEvents(tasksToExport)

      if (error) {
        console.log(error)
        return
      }

      window.open('data:text/calendar;charset=utf8,' + escape(value))

       */
    },
    setFilterView(viewKey) {
      Object.keys(this.filters.view).forEach(vKey => {
        this.filters.view[vKey].isActive = vKey === viewKey
      })
    }
  },
  watch: {
    '$props.tasks'(newTasks) {
      this.tL = newTasks
    },
    '$props.serviceShopId'(newServiceShopId) {
      this.serviceShopId = newServiceShopId
    }
  },
  mounted() {
    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      if (this.taskCollapse === undefined) {
        this.taskCollapse = []
      }
      if (isJustShown) {
        this.taskCollapse.push(collapseId)
      } else {
        this.taskCollapse = this.taskCollapse.filter(
          item => item !== collapseId
        )
      }

      
      if (this.taskCollapse.length  == Object.values(this.groupVisibility).filter((x) => x).length) {
        this.allOpen = true
      } else {
        this.allOpen = false
      }
    })
  },
  components: {
    BosButton,
    TaskItem,
    TaskItemGroup
  }
}
</script>

<style lang="scss">
@import '@/assets/css/variables.scss';

$tasklisting-margin: $component-margin !default;

$tasklisting-filter-margin: 2.25rem 0 !default;

$tasklisting-list-item-gap: 2.25rem !default;

.o-tasklisting {
  margin: $tasklisting-margin;

  .showall {
    display: block;
    padding: 0.5em 10px;
    background: none;
    border: 0 none;
    font-family: inherit;
    font-weight: bold;
    color: inherit;
    text-align: left;
    line-height: 19px;
    margin-right: 20px;

    svg {
      margin-right: 0.5em;
      width: 1em;
      height: 1em;
      color: $brand-primary;
    }
  }

  .tasklisting__filter {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    //    flex-wrap: wrap;
    margin: $tasklisting-filter-margin;

    > * {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin: -0.5em 0;
      padding: 0.5em 0;

      &.filter__left {
        display: block;
      }

      .flex__cell {
        background-color: Red;
      }

      .flex {
        display: flex !important;
        align-items: center;

        .v-text-field__details {
          display: none;
        }
      }

      > * {
        display: block;

        + * {
          margin-left: 0.66em;
        }
      }

      .v-select {
        display: inline-block;

        .vs__dropdown-toggle {
          border: 0 none;

          .vs__selected {
            position: static;
            white-space: nowrap;
          }

          .vs__search {
            display: none;
          }
        }
      }
    }
  }

  .tasklisting__list {
    margin: 0;
    padding: 0;
    list-style: none;

    .list__item {
      .task__title {
        //        margin-top: $tasklisting-list-item-gap;
      }

      .taskgroupitem__task {
        margin-top: $tasklisting-list-item-gap;
      }

      &:first-child {
        padding-top: 0;
      }
    }
  }
}
.o-taskgroupitem {
  .tasklisting__list {
    margin: 1rem 0 2rem 0;
  }

  .list__item {
    .o-taskitem {
      border-top: 1px solid #d7d7d7;
      margin: 0;

      .sm &,
      .xs & {
        margin: 0;
      }
    }

    &:first-of-type {
      .o-taskitem {
        border-top: none;
      }
    }
  }
}


.sortfilter {
  &.v-select {
    .v-select__selection {
      color: $brand-primary;
    }
  }
  &.v-text-field--outlined {
    fieldset {
      border: 1px solid black;
      border-radius: 10px;
    }
    &.v-input--has-state,
    &.v-input--is-focused {
      fieldset {
        border: 1px solid black;
        border-radius: 10px;
      }
    }
  }
}

.v-menu__content .v-list {
  .v-list-item--link {
    &::before {
      background-color: white;
      opacity: 0;
    }
    &.primary--text {
      background-color: $brand-primary;
      color: white !important;
    }
    &:hover {
      background-color: $brand-primary;
      color: white !important;
    }
  }
}

.dropdown_icon {
  display: block;
  width: 23px;
  height: 20px;
  background-image: url("~@/assets/images/icons/chevron_bold_down_primary_new.svg");
  background-size: 35px 20px;
  background-position: 0 0;
}
</style>
